import { MOBILE_BREAKPOINT } from '../utils/breakpoints';
import { useMediaQuery } from './useMediaQuery';

/**
 * True when the viewport is at or below the mobile breakpoint
 * (`max-width: ${MOBILE_BREAKPOINT - 1}px`). Single source of truth for the
 * mobile/desktop cutover — the new mobile chrome and mobile page layouts gate
 * on this.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}

export default useIsMobile;
